class freeProductAdd extends HTMLElement {
  constructor() {
    super();
    this.handleClick = this.handleClick.bind(this);
  }

  connectedCallback() {
    this.addEventListener('click', this.handleClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.handleClick);
  }

  getSectionsToRender() {
    return [
      {
        id: "cart-drawer__content",
        section: document.getElementById("cart-drawer__content").dataset.id,
        selector: ".cart-drawer__content",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
    ];
  }
  handleClick(event) {
    this.classList.add('loading');

    let currentVariant = this.getAttribute('data-current-variant');
      
    const items = [];
    const mainProd = {
      id: currentVariant,
      quantity: 1,
    };
    items.push(mainProd);
  
    const body = JSON.stringify({
      items,
      sections: this.getSectionsToRender().map((section) => section.section),
    });

    document.querySelector(".discount-announcements-heading")?.classList.add("hidden");
    document.querySelector(".discount-announcements-heading-discount-applied")?.classList.add("hidden");
    document.querySelector(".discount-announcements-heading-updating-discounts")?.classList.remove("hidden");

    fetch(`/cart/add.js`, {
      body,
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "xmlhttprequest",
      },
      method: "POST",
    })
    .then((response) => response.json())
    .then((parsedState) => {
      this.getSectionsToRender().forEach((section) => {
        const elementToReplace =
          document
            .getElementById(section.id)
            .querySelector(section.selector) ||
          document.getElementById(section.id);

        elementToReplace.innerHTML = getSectionInnerHTML(
          parsedState.sections[section.section],
          section.selector
        );

        if (typeof window.flyOutLoad === "function") {
          window.flyOutLoad();
        }

        let selectElements = document.querySelectorAll('.variant-options');
        selectElements.forEach(function(selectElement) {
          selectElement.addEventListener('change', function(e) {
            e.preventDefault();        
            let variantId = selectElement.value;
            let selectedOption = selectElement.options[selectElement.selectedIndex];
            let dataImg = selectedOption.getAttribute('data-img');
            
            this.closest('.item-content').querySelector('free-product-add').setAttribute('data-current-variant', variantId);
            this.closest('.item-content').querySelector('.image img').setAttribute('src', dataImg);
            this.closest('.item-content').querySelector('.image img').setAttribute('srcset', dataImg);
          });
        });

        this.classList.remove('loading');
        
      });
    })
    .catch((e) => {
      console.error(e);
    })
    .finally(() => {
      document.querySelector("cart-drawer").open();
      typeof window.updateDiscountAnnouncements === "function" &&
        window.updateDiscountAnnouncements();
    });

  }
}

document.addEventListener('DOMContentLoaded', () => {
  customElements.define("free-product-add", freeProductAdd);
  window.variantOptionChangeDrawer();
});

window.variantOptionChangeDrawer = function(){
  let selectElements = document.querySelectorAll('.variant-options');
  selectElements.forEach(function(selectElement) {
    selectElement.addEventListener('change', function(e) {
      e.preventDefault();
  
      let variantId = selectElement?.value;
      let selectedOption = selectElement?.options[selectElement?.selectedIndex];
      let dataImg = selectedOption?.getAttribute('data-img');
  
      this.closest('.item-content').querySelector('free-product-add').setAttribute('data-current-variant', variantId);
      this.closest('.item-content').querySelector('.image img').setAttribute('src', dataImg);
      this.closest('.item-content').querySelector('.image img').setAttribute('srcset', dataImg);
    });
  });
  
}